export default __webpack_public_path__ + "src/assets/ledger.f9c1feaa2176868a770a0dc9b8fabcfd.svg";